import { render, staticRenderFns } from "./allEnterprise.vue?vue&type=template&id=63a89bf0&scoped=true"
import script from "./allEnterprise.vue?vue&type=script&lang=js"
export * from "./allEnterprise.vue?vue&type=script&lang=js"
import style0 from "./allEnterprise.vue?vue&type=style&index=0&id=63a89bf0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a89bf0",
  null
  
)

export default component.exports